import { useState } from 'react';
import { useMutation } from "@apollo/client/react";
import {
	DialogTitle,
	DialogActions,
	DialogContent,
	Button,
} from 'components/dialogs/DialogBox';

import ErrorMessage from 'components/ErrorMessage';

import Form from 'web/form/Form';
import { PepFields } from 'web/components/user/UserInputFields';
import FormIntroText from 'components/form/FormIntroText';

import { VERIFY_ONE_USER_PEP } from 'api/mutations/userMutations';

export default function PEPVerifyModal({ _id }) {
	const [error, setError] = useState(null);

	const [verifyPEP, { loading: verifyPepLoading, error: verifyPEPError }] =
		useMutation(VERIFY_ONE_USER_PEP, {
			refetchQueries: ['currentUser'],
		});

	const handleSubmit = async ({
		isPoliticallyExposedPerson: isPEP,
		userPoliticallyExposedPersonRoles: roles,
	}) => {
		try {
			setError(null);

			if (isPEP && roles.length === 0) {
				setError('Mangler relasjoner for politisk eksponert person');
				return;
			}

			await verifyPEP({
				variables: {
					_id,
					isPEP,
					roles: isPEP ? roles : null,
				},
			});
		} catch (err) {
			console.error(err);
		}
	};

	return (
		<>
			<DialogTitle id="user-verification-dialog-title">
				Du må oppgi om du er en politisk eksponert person
			</DialogTitle>

			<ErrorMessage errors={[error, verifyPEPError]} />

			<Form onSubmit={handleSubmit}>
				<DialogContent sx={{ paddingTop: 0 }}>
					<FormIntroText>
						For å kunne benytte tjenesten vår, må du avgi en
						erklæring på om du, eller noen i din nærmeste krets, er
						en politisk eksponert person.
					</FormIntroText>

					<PepFields />
				</DialogContent>

				<DialogActions>
					<Button
						variant="contained"
						color="primary"
						type="submit"
						loading={verifyPepLoading}
					>
						Bekreft
					</Button>
				</DialogActions>
			</Form>
		</>
	);
}
